export default class CalendarUtils {
  /**
   * Returns first day visible in calendar "card"
   */
  static getStartDay (year, month, onlySelectedMonth = false) {
    let date = new Date(year, month - 1, 1, 12, 0, 0, 0);
    let dayNumber = date.getDay();

    if (dayNumber > 0 && !onlySelectedMonth) {
      date.setTime(date.getTime() - ((dayNumber - 1) * 24 * 60 * 60 * 1000));
    } else if (dayNumber === 0 && !onlySelectedMonth) {
      date.setTime(date.getTime() - (6 * 24 * 60 * 60 * 1000));
    }

    return this.formatDateForPHP(date);
  }

  /**
   * Returns last day visible in calendar "card"
   */
  static getEndDay (year, month, onlySelectedMonth = false) {
    let dateTemp = new Date(year, month, 0, 12, 0, 0, 0);
    let date = new Date(year, month - 1, dateTemp.getDate(), 12, 0, 0, 0);
    let dayNumber = date.getDay();

    if (dayNumber > 0 && !onlySelectedMonth) {
      date.setTime(date.getTime() + ((7 - dayNumber) * 24 * 60 * 60 * 1000));
    }

    return this.formatDateForPHP(date);
  }

  /**
   * Returns date since provided current date with given diff
   */
  static getDay (currentDate, diff) {
    let dateArray = currentDate.split('-').map(num => parseInt(num, 10));
    let newDate = new Date(dateArray[0], dateArray[1] - 1, dateArray[2], 0, 0, 0, 0);
    newDate.setDate(newDate.getDate() + diff);

    return this.formatDateForPHP(newDate);
  }

  /**
   * Returns list of dates in a given period
   */
  static getDaysList (year, month) {
    let start = this.getStartDay(year, month);
    let end = this.getEndDay(year, month);
    let startArray = start.split('-').map(num => parseInt(num, 10));
    let endArray = end.split('-').map(num => parseInt(num, 10));
    let endDate = new Date(endArray[0], endArray[1] - 1, endArray[2], 0, 0, 0, 0);
    let today = new Date();
    let tempDate = new Date(startArray[0], startArray[1] - 1, startArray[2], 0, 0, 0);
    let days = [];

    while (tempDate.getTime() <= endDate.getTime()) {
      days.push({
        number: tempDate.getDate(),
        date: this.formatDateForPHP(tempDate),
        isCurrentMonth: tempDate.getMonth() + 1 === month,
        isToday: today.getFullYear() === tempDate.getFullYear() && today.getMonth() === tempDate.getMonth() && today.getDate() === tempDate.getDate()
      });
      tempDate.setDate(tempDate.getDate() + 1);
    }

    return days;
  }

  /**
   * Format JS Date object for use with PHP REST API
   */
  static formatDateForPHP (date) {
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(num => num < 10 ? '0' + num : num).join('-');
  }

  /**
   * Returns day name according to given day number
   */
  static getDayName (dayNumber, short = false) {
    switch (dayNumber) {
      case 1: return short ? window.bookero.translations.$t('calendar.day1.short') : window.bookero.translations.$t('calendar.day1.long');
      case 2: return short ? window.bookero.translations.$t('calendar.day2.short') : window.bookero.translations.$t('calendar.day2.long');
      case 3: return short ? window.bookero.translations.$t('calendar.day3.short') : window.bookero.translations.$t('calendar.day3.long');
      case 4: return short ? window.bookero.translations.$t('calendar.day4.short') : window.bookero.translations.$t('calendar.day4.long');
      case 5: return short ? window.bookero.translations.$t('calendar.day5.short') : window.bookero.translations.$t('calendar.day5.long');
      case 6: return short ? window.bookero.translations.$t('calendar.day6.short') : window.bookero.translations.$t('calendar.day6.long');
      case 0: return short ? window.bookero.translations.$t('calendar.day7.short') : window.bookero.translations.$t('calendar.day7.long');
    }
  }

  /**
   * Returns day name according to given date
   */
  static getDayNameFromDate (date, short = false) {
    date = date.split('-').map(n => parseInt(n, 10));
    let dateObject = new Date(date[0], date[1] - 1, date[2]);
    let dayNumber = dateObject.getDay();

    return this.getDayName(dayNumber, short);
  }

  /**
   * Returns month name according to given month number
   */
  static getMonthName (monthNumber, short = false) {
    switch (monthNumber) {
      case 1: return short ? window.bookero.translations.$t('calendar.month1.short') : window.bookero.translations.$t('calendar.month1.long');
      case 2: return short ? window.bookero.translations.$t('calendar.month2.short') : window.bookero.translations.$t('calendar.month2.long');
      case 3: return short ? window.bookero.translations.$t('calendar.month3.short') : window.bookero.translations.$t('calendar.month3.long');
      case 4: return short ? window.bookero.translations.$t('calendar.month4.short') : window.bookero.translations.$t('calendar.month4.long');
      case 5: return short ? window.bookero.translations.$t('calendar.month5.short') : window.bookero.translations.$t('calendar.month5.long');
      case 6: return short ? window.bookero.translations.$t('calendar.month6.short') : window.bookero.translations.$t('calendar.month6.long');
      case 7: return short ? window.bookero.translations.$t('calendar.month7.short') : window.bookero.translations.$t('calendar.month7.long');
      case 8: return short ? window.bookero.translations.$t('calendar.month8.short') : window.bookero.translations.$t('calendar.month8.long');
      case 9: return short ? window.bookero.translations.$t('calendar.month9.short') : window.bookero.translations.$t('calendar.month9.long');
      case 10: return short ? window.bookero.translations.$t('calendar.month10.short') : window.bookero.translations.$t('calendar.month10.long');
      case 11: return short ? window.bookero.translations.$t('calendar.month11.short') : window.bookero.translations.$t('calendar.month11.long');
      case 12: return short ? window.bookero.translations.$t('calendar.month12.short') : window.bookero.translations.$t('calendar.month12.long');
    }
  }

  /**
   * Returns month name according to given month number
   */
  static getMonthNameGenitive (monthNumber) {
    monthNumber = parseInt(monthNumber, 10);

    switch (monthNumber) {
      case 1: return window.bookero.translations.$t('calendar.month1.genitive');
      case 2: return window.bookero.translations.$t('calendar.month2.genitive');
      case 3: return window.bookero.translations.$t('calendar.month3.genitive');
      case 4: return window.bookero.translations.$t('calendar.month4.genitive');
      case 5: return window.bookero.translations.$t('calendar.month5.genitive');
      case 6: return window.bookero.translations.$t('calendar.month6.genitive');
      case 7: return window.bookero.translations.$t('calendar.month7.genitive');
      case 8: return window.bookero.translations.$t('calendar.month8.genitive');
      case 9: return window.bookero.translations.$t('calendar.month9.genitive');
      case 10: return window.bookero.translations.$t('calendar.month10.genitive');
      case 11: return window.bookero.translations.$t('calendar.month11.genitive');
      case 12: return window.bookero.translations.$t('calendar.month12.genitive');
    }
  }

  /**
   * Returns days list for given month and year
   */
  static getMonthDays (month, year, useShortNames = true) {
    let numberOfDays = new Date(year, month, 0).getDate();
    let days = Array.from({length: numberOfDays}, (v, k) => k + 1);

    return days.map(day => {
      let tempDate = new Date(year, month - 1, day);

      return {
        day: day,
        name: this.getDayName(tempDate.getDay(), useShortNames)
      };
    });
  }

  /**
   * Get day names for a given range
   */
  static getDayNames (periodStart, diff) {
    let startArray = periodStart.split('-').map(num => parseInt(num, 10));
    let startDate = new Date(startArray[0], startArray[1] - 1, startArray[2], 0, 0, 0, 0);
    let names = [];

    names.push({
      name: startDate.getDate() + ' ' +
            this.getMonthName(startDate.getMonth() + 1, true) + ' - ' +
            this.getDayName(startDate.getDay()) + ':',
      date: this.formatDateForPHP(startDate)
    });

    for (let i = 1; i < diff; i++) {
      startDate.setDate(startDate.getDate() + 1);
      names.push({
        name: startDate.getDate() + ' ' +
              this.getMonthName(startDate.getMonth() + 1, true) + ' - ' +
              this.getDayName(startDate.getDay()) + ':',
        date: this.formatDateForPHP(startDate)
      });
    }

    return names;
  }

  /**
   * Calculates next/prev date
   */
  static getDiffDate (startDate, diff) {
    let startArray = startDate.split('-').map(num => parseInt(num, 10));
    let newDate = new Date(startArray[0], startArray[1] - 1, startArray[2], 0, 0, 0, 0);
    newDate.setDate(newDate.getDate() + diff);

    return this.formatDateForPHP(newDate);
  }

  /**
   * Transform date to more human format
   */
  static humanDateFormat (date, withHour = true, showDayName = false) {
    if (withHour) {
      let tempParts = date.split(' ');
      let dateParts = tempParts[0].split('-');
      let timePart = tempParts[1];

      if (dateParts[2][0] === '0' && dateParts[2].length) {
        dateParts[2] = dateParts[2][1];
      }

      return [dateParts[2], this.getMonthNameGenitive(dateParts[1]), dateParts[0], window.bookero.translations.$t('calendar.other.at_hour'), timePart].join(' ');
    }

    let dateParts = date.split(' ');
    dateParts = dateParts[0];
    dateParts = dateParts.split('-');

    if (dateParts[2][0] === '0' && dateParts[2].length) {
      dateParts[2] = dateParts[2][1];
    }

    if (showDayName) {
      let dateObject = new Date(parseInt(dateParts[0], 10), parseInt(dateParts[1] - 1, 10), parseInt(dateParts[2], 10));
      let dayNumber = dateObject.getDay();
      let dayName = '';

      switch (dayNumber) {
        case 0: dayName = window.bookero.translations.$t('calendar.day7.long'); break;
        case 1: dayName = window.bookero.translations.$t('calendar.day1.long'); break;
        case 2: dayName = window.bookero.translations.$t('calendar.day2.long'); break;
        case 3: dayName = window.bookero.translations.$t('calendar.day3.long'); break;
        case 4: dayName = window.bookero.translations.$t('calendar.day4.long'); break;
        case 5: dayName = window.bookero.translations.$t('calendar.day5.long'); break;
        case 6: dayName = window.bookero.translations.$t('calendar.day6.long'); break;
      }

      return [dayName + ',', dateParts[2], this.getMonthNameGenitive(dateParts[1]), dateParts[0]].join(' ');
    }

    return [dateParts[2], this.getMonthNameGenitive(dateParts[1]), dateParts[0]].join(' ');
  }

  /**
   * Generate dates range if necessary
   */
  static humanDateFormatRange (date, days, freeInNextDay) {
    let tempParts = date.split(' ');
    let dateParts = tempParts[0].split('-');
    let startDateObject = new Date(parseInt(dateParts[0], 10), parseInt(dateParts[1] - 1, 10), parseInt(dateParts[2], 10));
    let endDateObject = new Date(parseInt(dateParts[0], 10), parseInt(dateParts[1] - 1, 10), parseInt(dateParts[2], 10));

    if (freeInNextDay) {
      endDateObject.setDate(endDateObject.getDate() + parseInt(days, 10));
    } else {
      endDateObject.setDate((endDateObject.getDate() + parseInt(days, 10)) - 1);
    }

    let startDateText = [startDateObject.getFullYear(), startDateObject.getMonth() + 1, startDateObject.getDate()].map(n => n < 10 ? '0' + n : n).join('-');
    let endDateText = [endDateObject.getFullYear(), endDateObject.getMonth() + 1, endDateObject.getDate()].map(n => n < 10 ? '0' + n : n).join('-');

    if (startDateText === endDateText) {
      return CalendarUtils.humanDateFormat(startDateText, false, true);
    }

    return CalendarUtils.humanDateFormat(startDateText, false, true) + ' - ' + CalendarUtils.humanDateFormat(endDateText, false, true);
  }

  /**
   * Generate dates range
   */
  static humanDateRange (dateStart, dateEnd) {
    let startTempParts = dateStart.split(' ');
    let endTempParts = dateEnd.split(' ');
    let startDateParts = startTempParts[0].split('-');
    let endDateParts = endTempParts[0].split('-');
    let startDateObject = new Date(parseInt(startDateParts[0], 10), parseInt(startDateParts[1] - 1, 10), parseInt(startDateParts[2], 10));
    let endDateObject = new Date(parseInt(endDateParts[0], 10), parseInt(endDateParts[1] - 1, 10), parseInt(endDateParts[2], 10));

    let startDateText = [startDateObject.getDate(), this.getMonthNameGenitive(startDateObject.getMonth() + 1)].join(' ');
    let endDateText = [endDateObject.getDate(), this.getMonthNameGenitive(endDateObject.getMonth() + 1)].join(' ');
    let startYear = startDateObject.getFullYear();
    let endYear = endDateObject.getFullYear();

    if (startYear === endYear) {
      startYear = '';
    }

    return startDateText + ' ' + startYear + ' - ' + endDateText + ' ' + endYear;
  }

  /**
   * Transform date to more human format
   */
  static humanDateFormatMonth (date) {
    let dateParts = date.split(' ');
    dateParts = dateParts[0];
    dateParts = dateParts.split('-');

    return [this.getMonthName(parseInt(dateParts[1], 10)), dateParts[0]].join(' ');
  }

  /**
   * Converts string YYYY-MM-DD to Date object
   */
  static convertStringToDate (stringDate) {
    let date = stringDate.split('-').map(num => parseInt(num, 10));
    let convertedDate = new Date(date[0], date[1] - 1, date[2], 0, 0, 0, 0);

    return convertedDate;
  }

  /**
   * Converts string YYYY-MM-DD hh:mm:ss to Date object
   */
  static convertDateTimeStringToDate (stringDate) {
    let datetime = stringDate.split(' ');
    let date = datetime[0].split('-').map(num => parseInt(num, 10));
    let time = datetime[1].split(':').map(num => parseInt(num, 10));
    let convertedDate = new Date(date[0], date[1] - 1, date[2], time[0], time[1], time[2], 0);

    return convertedDate;
  }

  /**
   * Converts string to timestamp
   */
  static convertDateToTimestamp (stringDate) {
    return +CalendarUtils.convertStringToDate(stringDate);
  }

  /**
   * Converts timestamp to string
   */
  static convertTimestampToString (timestamp) {
    let date = new Date();
    date.setTime(timestamp);

    return [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(n => n < 10 ? '0' + n : n).join('-');
  }
};



// WEBPACK FOOTER //
// ./src/components/helpers/CalendarUtils.js